import Reveal from "@/components/base/Reveal";

export default function CtaSection() {
  return (
    <section id="contact" className="relative w-full px-4 md:px-6 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20stylized%20sunset%20over%20rolling%20terraced%20farm%20fields%20with%20bamboo%20pavilions%20and%20distant%20mountains%2C%20warm%20golden%20and%20deep%20green%20gradient%20sky%2C%20peaceful%20inspiring%20atmosphere%2C%20artistic%20painterly%20illustration%2C%20rich%20warm%20color%20palette%2C%20dreamy%20composition&width=1600&height=700&seq=home-cta-1&orientation=landscape"
          alt="味聚华夏农耕酵素农场 · 立即认种"
          title="味聚华夏农耕酵素农场 · 认种一块田"
          loading="lazy"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 to-primary-900/60"></div>

      <Reveal className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white">
          认种一块田，开启你的田园共生之旅
        </h2>
        <p className="text-white/85 text-sm md:text-base mt-4 leading-relaxed max-w-xl mx-auto">
          无论你是连锁餐饮、企业集团、家族宗亲，还是城市家庭、兴趣社群，都能在味聚华夏找到属于你的那一方田园。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="#home"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-seedling-line"></i>
            立即认种
          </a>
          <a
            href="#concept"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-white/15 backdrop-blur text-white text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-building-2-line"></i>
            预约城市改造
          </a>
        </div>
      </Reveal>
    </section>
  );
}